// @flow
import { OPEN_SNACKBAR, OPEN_SNACKBAR_ERROR, CLOSE_SNACKBAR } from './actionTypes';

export function openSnackbar(message: Object): TrovitAction {
  return {
    type: OPEN_SNACKBAR,
    payload: {
      message,
    },
  };
}

export function openSnackbarError(message?: Object): TrovitAction {
  return {
    type: OPEN_SNACKBAR_ERROR,
    payload: {
      message,
    },
  };
}

export function closeSnackbar(): TrovitAction {
  return {
    type: CLOSE_SNACKBAR,
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/Snackbar/actions.js